export const DEFAULT_MAX_WIDTH = 800;
export const DEFAULT_MAX_HEIGHT = 600;

export const RED_OVERLAY_COLOR = 'rgba(255, 0, 0, 0.5)';
export const BRUSH_COLOR = 'rgba(255, 0, 0, 1)'; // Alpha will be applied to CSS
